import { msg } from '@lingui/core/macro';
import { translateLazy } from '@utils/translations.ts';
import type { TablePaginationConfig } from 'antd';
import type { TablePaginationPlacement } from 'antd/es/table/interface';

export const PAGINATION_DEFAULT_OPTIONS: TablePaginationConfig = {
    placement: ['bottomEnd'] as TablePaginationPlacement[],
    showSizeChanger: { showSearch: false },
    showQuickJumper: false, // turn off search by page number
    pageSizeOptions: ['10', '20', '50', '100'],
    locale: { items_per_page: '' },
};

export const EDITABLE_FIELDS = {
    INPUT_TEXT: 'inputText',
    INPUT_NUMBER: 'inputNumber',
    SINGLE_SELECT: 'singleSelect',
    MULTI_SELECT: 'multiSelect',
    CUSTOM_COMMON_MULTI_SELECT: 'customCommonMultiSelect',
    CUSTOM_SINGLE_SELECT_MATRICES: 'customSingleSelectMatrices',
    CUSTOM_SINGLE_SELECT: 'customSingleSelect',
    CUSTOM_MULTI_SELECT_MATRICES_VESSELS: 'customMultiSelectMatricesVessels',
    CUSTOM_MULTI_SELECT_MATRICES_RANKS: 'customMultiSelectMatricesRanks',
    TOGGLE: 'toggle',
    TOGGLE_CONTROLLED: 'toggleControlled', // update toggle value based on external confirmation, e.g. via modal
    DATE_PICKER: 'date',
};

export const NOT_SET_LABEL = translateLazy(msg`– Not set`);
